"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'cost.preview.title': 'Usage Cost Details',
    'cost.preview.back': 'Back to Reports',
    'cost.preview.loading': 'Loading cost details...',
    'cost.preview.error.load_failed': 'Failed to load usage cost details',
    'cost.preview.not_found.title': 'Cost Entry Not Found',
    'cost.preview.not_found.description': 'The requested usage cost entry could not be found or you do not have permission to view it.',
    'cost.preview.section.token_usage': 'Token Usage',
    'cost.preview.section.cost_info': 'Cost Information',
    'cost.preview.section.performance': 'Performance Metrics',
    'cost.preview.section.context_info': 'Context Information',
    'cost.preview.reasoning_tokens': 'Reasoning Tokens',
    'cost.preview.cached_tokens': 'Cached Tokens',
    'cost.preview.upstream_cost': 'Upstream Cost',
    'cost.preview.cost_per_token': 'Cost per 1M Tokens',
    'cost.preview.cost_type': 'Cost Type',
    'cost.preview.type.standard': 'Standard',
    'cost.preview.response_time': 'Total Response Time',
    'cost.preview.response_begin_time': 'Time to First Token',
    'cost.preview.efficiency': 'Processing Efficiency',
    'cost.preview.efficiency.excellent': 'Excellent',
    'cost.preview.efficiency.good': 'Good',
    'cost.preview.efficiency.average': 'Average',
    'cost.preview.efficiency.slow': 'Slow',
    'cost.preview.efficiency.unknown': 'Unknown',
    'cost.preview.time.not_available': 'N/A',
    'cost.preview.no_tools': 'No tools used',
    'cost.preview.message_id': 'Message ID',
    'cost.preview.user.unknown': 'Unknown User',
    'cost.preview.avatar.none': 'No Avatar',
    'cost.preview.model.unknown': 'Unknown Model',
    'cost.preview.view_details': 'View Details',
};
